import { HCConfig, HCConfigAssets, HCConfigFeatures, HCConfigRules } from './hc-config';

export const iasep: HCConfig = {
         appName: 'Telessaúde IASEP',
         hcId: '',
         isPublic: true,
         uf: 'PA',
         config: {
           trackingId: 'G-9V991C81Y5',
           domain: 'app.telessaudeiasep.com.br',
           hcParam: 'iasep',
           domainKey: 'appIasepDomainUrl',
           reactDomainKey: 'appIasepDomainReactUrl',
           clientDomainHeader: 'iasep-para',
           clientDomain: 'iasep-para',
           govBrClientId: 'cuidar-piaui-gov-pi',
           supportChatKey:
             'ZWZhYTAzYTktM2ViZi00NjIyLTk1YTUtNzE3MmE0MWE3MGNjOmU4YmM0YjQwMjY4NTQ2ODFkZDM1ZDhmMDI3NWRjYTc4YTU2NTg3MjJjZXNwMDA3MG4yZ0FsQ0dzYzExS0lTOE9uejNtY3dvRmg1SzhvRDJqcWc=',
         },

         assets: {
           logo: HCConfigAssets.mainLogo('iasep'),
           uploadExternalFilesLogo: HCConfigAssets.uploadExternalFilesLogo('iasep'),
           preloaderLogo: HCConfigAssets.preloaderLogo('iasep'),
           favicon: HCConfigAssets.favicon('iasep'),
         },

         links: {
           site: 'https://app.telessaudeiasep.com.br',
           termsOfUse: 'https://telessaudeiasep.com.br/termos-de-uso-iasep.html',
           policyPrivacy: 'https://telessaudeiasep.com.br/politica-de-privacidade-iasep.html',
           playstore: 'https://play.google.com/store/apps/details?id=com.ptm.iaseppara',
           appstore: 'https://apps.apple.com/us/app/telessaúde-iasep/id6753757697',
         },

         dataDeletion: {
           name: 'IASEP Saúde Digital',
           slug: 'iasep',
           agreementTermsUrl: 'https://telessaudeiasep.com.br/termo-de-consentimento-exclusao-conta-iasep.html',
           background: '#ffffff',
           logo: {
             src: HCConfigAssets.dataDeletionLogo('iasep'),
             width: 340,
             height: 101,
           },
         },

         firstAccess: {
           name: 'IASEP Saúde Digital',
           abbreviation: 'iasep',
           emailDomain: '@iasep.gov.br',
           slug: 'iasep',
           city: 'Pará',
           background: 'linear-gradient(45deg, #2d8efb, #034ea2 35%, #023f82)',
           logo: {
             src: HCConfigAssets.firstAccessLogo('iasep'),
             width: 300,
             height: 90,
           },
         },

         mealPlan: {
           enableDocumentCreation: false,
           enableSendFiles: true,
           documentTypes: {
             showMealPlan: true,
             showTherapeuticPlan: false,
             showNursingPlan: false,
           },
         },

         routes: {
           firstAccess: '/first-access/iasep',
         },

         features: [
           HCConfigFeatures.FIRST_ACCESS_SEE_MORE_CONTENT,
           HCConfigFeatures.FIRST_ACCESS_REGISTER,
           HCConfigFeatures.PROCEDURES_APAC_SADT,
           HCConfigFeatures.REFERRAL_GUIDE,
           HCConfigFeatures.REQUEST_ATTENDANCE,
           HCConfigFeatures.HC_ADM_CAN_CHANGE_PATIENT_PASSWORD,
           HCConfigFeatures.PATIENT_COMPLEMENTARY_DATA_FORM_INCLUDE_PHONE,
           HCConfigFeatures.PATIENT_INVITE_AND_EDIT_FORM_INCLUDE_EXTERNAL_ID,
           HCConfigFeatures.MANCHESTER_QUESTIONNAIRE,
           HCConfigFeatures.BULK_DEACTIVATION_BENEFICIARIES,
           HCConfigFeatures.CAMERA_MIC_PREVIEW_BEFORE_CALL_JOIN,
         ],

         rules: [
           HCConfigRules.PATIENT_COMPLEMENTARY_DATA_FORM_DISABLE_CPF,
           HCConfigRules.PATIENT_COMPLEMENTARY_DATA_FORM_REQUIRE_PHONE,
           HCConfigRules.PATIENT_INVITE_AND_EDIT_FORM_REQUIRE_CPF,
           HCConfigRules.PATIENT_INVITE_AND_EDIT_FORM_REQUIRE_EXTERNAL_ID,
           HCConfigRules.APPOINTMENT_MANAGEMENT,
           HCConfigRules.BLOCK_REGISTRATION_WITH_OUT_OF_STATE_ZIPCODE,
           HCConfigRules.PHYSICIAN_SIGNATURE_STATUS_WIDGET,
           HCConfigRules.DOCTORS_LIST_SHOW_DIGITAL_SIGNATURE_STATUS,
         ],
       };
